import React from 'react';
import { AVATARS } from '../../utils/avatars';

export default function AvatarSelector({ selectedAvatar, onSelect, size = 'medium' }) {
  const sizeMap = {
    small: { container: 50, emoji: 30 },
    medium: { container: 80, emoji: 48 },
    large: { container: 120, emoji: 72 },
  };

  const dimensions = sizeMap[size] || sizeMap.medium;

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))',
      gap: '1rem',
      padding: '1rem 0',
    }}>
      {AVATARS.map((avatar) => (
        <button
          key={avatar.id}
          onClick={() => onSelect(avatar.id)}
          style={{
            width: '100%',
            aspectRatio: '1',
            border: selectedAvatar === avatar.id ? '3px solid #5625D8' : '2px solid #ddd',
            borderRadius: '12px',
            backgroundColor: avatar.color,
            cursor: 'pointer',
            transition: 'all 0.2s',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.25rem',
            padding: '0.5rem',
            boxShadow: selectedAvatar === avatar.id
              ? '0 4px 12px rgba(86, 37, 216, 0.3)'
              : '0 2px 4px rgba(0,0,0,0.1)',
            transform: selectedAvatar === avatar.id ? 'scale(1.05)' : 'scale(1)',
          }}
          type="button"
        >
          <span style={{ fontSize: '48px', lineHeight: 1 }}>
            {avatar.emoji}
          </span>
          <span style={{
            fontSize: '11px',
            fontWeight: 'bold',
            color: '#333',
            textAlign: 'center'
          }}>
            {avatar.name}
          </span>
        </button>
      ))}
    </div>
  );
}

// Avatar Display Component (for showing selected avatar)
export function AvatarDisplay({ avatarId, size = 'medium', showName = false }) {
  const sizeMap = {
    tiny: { container: 32, emoji: 20 },
    small: { container: 50, emoji: 30 },
    medium: { container: 80, emoji: 48 },
    large: { container: 120, emoji: 72 },
    xlarge: { container: 160, emoji: 96 },
  };

  const dimensions = sizeMap[size] || sizeMap.medium;
  const avatar = AVATARS.find(a => a.id === avatarId) || AVATARS[0];

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '0.5rem',
    }}>
      <div style={{
        width: `${dimensions.container}px`,
        height: `${dimensions.container}px`,
        borderRadius: '50%',
        backgroundColor: avatar.color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid #fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}>
        <span style={{ fontSize: `${dimensions.emoji}px`, lineHeight: 1 }}>
          {avatar.emoji}
        </span>
      </div>
      {showName && (
        <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#666' }}>
          {avatar.name}
        </span>
      )}
    </div>
  );
}
